import { render } from "./App.vue?vue&type=template&id=dc5873ae"
const script = {}

import "./App.vue?vue&type=style&index=0&id=dc5873ae&lang=scss"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__